// Polaris ships official UI dictionaries for its own component internals
// (Banner dismiss buttons, EmptyState actions, date pickers, …). App.js used
// to pass i18n={{}}, which blanks them to English; the app now passes the
// dictionary matching the merchant's chosen admin language. Polaris has no
// Ukrainian file, so uk falls back to English there — our own strings stay
// translated regardless.
import en from '@shopify/polaris/locales/en.json';
import zhCN from '@shopify/polaris/locales/zh-CN.json';
import zhTW from '@shopify/polaris/locales/zh-TW.json';
import ja from '@shopify/polaris/locales/ja.json';
import ko from '@shopify/polaris/locales/ko.json';
import fr from '@shopify/polaris/locales/fr.json';
import de from '@shopify/polaris/locales/de.json';
import it from '@shopify/polaris/locales/it.json';
import es from '@shopify/polaris/locales/es.json';
import ptPT from '@shopify/polaris/locales/pt-PT.json';
import nl from '@shopify/polaris/locales/nl.json';
import pl from '@shopify/polaris/locales/pl.json';

const POLARIS = {
  en,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  ja,
  ko,
  fr,
  de,
  it,
  es,
  'pt-PT': ptPT,
  nl,
  uk: en,
  pl
};

export function polarisTranslations(locale) {
  return POLARIS[locale] || en;
}
